import { nanoid } from "@reduxjs/toolkit";
import { api } from "../../app/api";

export interface SliceState {
  [key: string]: {
    [key: string]: string;
  };
}

export type LanguageCode = "fi" | "en" | "sv";

export const localizationSupportIndex = (languageCode: LanguageCode) => {
  return api
    .get<SliceState>("/projections/qry/categoryNames", {
      requestId: nanoid(),
      auth: true,
      queryParams: {
        languageCode,
      },
    })
    .then((res) => res.data);
};
